import { getLayoutType, getMinimumNumberOfPages, TEMPLATE_LAYOUT } from 'editor-utils/template';
import { generatePage } from './utils';

/**
 * Generate Blank data
 * @param {object} template
 * @returns {{ data: { pages: Array, photos: Array }}}
 */
const generateBlankData = async template => {
  const pages = [];
  const minimumNumberOfPages = getMinimumNumberOfPages(template, false);

  if (template.cover) {
    // GENERATE COVER
    pages.push(generatePage(template.cover[0]));
  }

  // GENERATE PAGES
  if (getLayoutType(template) === TEMPLATE_LAYOUT.AUTOMATIC) {
    const blankPage = template.pages.find(p => p.id === 'blank') ?? template.pages[0];
    for (let i = 0; i < minimumNumberOfPages; ) {
      pages.push(generatePage(blankPage));
      if (blankPage.span) {
        i += 2;
      } else {
        i += 1;
      }
    }
  }

  return {
    data: {
      pages,
      photos: [],
    },
  };
};

export default generateBlankData;
